export enum SingleSelectTypeEnum {
    License = 'license',
    Progress = 'progress',
    Groups = 'groups',
    Sources = 'sources',
    Chapter = 'chapter',
    LicenseOnColor = 'LicenseOnColor',
    TeacherMaterial = 'teacher-material',
}
